import { useNewProjectJourneyContext } from "./NewProjectJourneyContext";

interface UseNewProjectJourneyReturnData {
  CurrentStep: () => JSX.Element;
  /** A one-step journey has nothing to step between, so it shows no stepper. */
  hasStepper: boolean;
}

export const useNewProjectJourney = (): UseNewProjectJourneyReturnData => {
  const { steps, currentStep } = useNewProjectJourneyContext();

  const current = steps.find((step) => step.key === currentStep) ?? steps[0];

  return {
    CurrentStep: current.Component,
    hasStepper: steps.length > 1,
  };
};
